import { Link } from "react-router-dom";
import { env } from "@/config/env";
import { withCurrentSearch } from "@/utils/searchParams";
import { getHorizonScanningSession } from "./sessionKeys";

export function CheckEmailScreen() {
  const email = getHorizonScanningSession("email") ?? "your work address";
  const pendingId = getHorizonScanningSession("pending-id");
  const mock = getHorizonScanningSession("pending");
  let mockToken: string | null = null;
  try {
    mockToken = mock ? (JSON.parse(mock) as { token?: string }).token ?? null : null;
  } catch {
    mockToken = null;
  }
  // Prefer BFF pendingId (real signup) over a stale mock session token.
  const devToken = env.isDev ? pendingId ?? (env.useMockApi ? mockToken : null) : null;

  return (
    <div className="mx-auto grid w-full max-w-6xl flex-1 items-start gap-10 px-5 py-16 lg:grid-cols-[1.1fr_0.9fr]">
      <div>
        <h1 className="text-3xl font-extrabold text-ink">Check your inbox</h1>
        <p className="mt-4 text-lg text-ink-soft">
          We sent a confirm link to <strong>{email}</strong>. Clicking it creates the organisation and makes that
          address the admin.
        </p>
        <p className="mt-4 text-sm text-ink-muted">
          Did not get it? Check spam, and add @requirementone.com to your safe senders list.
        </p>
        {devToken ? (
          <p className="mt-6 rounded-xl border border-amber-200 bg-amber-50 p-4 text-sm text-ink-soft">
            Local development:{" "}
            <Link className="font-semibold text-brand-700 underline" to={`/horizonscanning/confirm?token=${devToken}`}>
              Confirm this signup
            </Link>
          </p>
        ) : null}
        <Link to={withCurrentSearch("/horizonscanning/start")} className="mt-8 inline-block text-sm text-brand-700">
          Back to the wizard
        </Link>
      </div>
      <img
        src="/img/placeholder-confirm.svg"
        alt="Confirmed check and inbox link"
        width={640}
        height={800}
        className="hidden h-auto w-full max-w-md lg:block"
      />
    </div>
  );
}
